// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__28f-D","rightAdornment":"Header_rightAdornment__1Qo7f"};